"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";
import { createSelectFieldDS, getControlDXType, getD5EditorType, getDatePlaceholder, getFieldFormat, getLinkedName, getObjectFieldType, getObjLinkedKeyName, getTitlePosition, isLookup, itemWithIconTemplate } from "D5Utils/functions";
import FieldsFactory from "D5Utils/FieldsFactory";
import { Messages } from "Messages";
import { formEditCustomAction } from "UserActionHandler/UserScriptActions";
import GroupsBuilder from "./GroupsBuilder";

var FormItemsBuilder =
/*#__PURE__*/
function () {
  /**
   * @param {Array} formFields
   * @param {Array} groups
   * @param {object} formData
   * @param {string} objectName
   * @param {FormEditStore} formEdit
   */
  function FormItemsBuilder(_ref) {
    var formFields = _ref.formFields,
        groups = _ref.groups,
        formData = _ref.formData,
        objectName = _ref.objectName,
        formEdit = _ref.formEdit;

    _classCallCheck(this, FormItemsBuilder);

    _defineProperty(this, "_formFields", []);

    _defineProperty(this, "_groups", []);

    _defineProperty(this, "_formData", {});

    _defineProperty(this, "_objectName", '');

    _defineProperty(this, "formEdit", null);

    this._formFields = formFields;
    this._groups = groups;
    this._formData = formData;
    this._objectName = objectName;
    this._formEdit = formEdit;
    this._fieldContainers = new Map();
    this._buttonContainers = new Map();
  }

  _createClass(FormItemsBuilder, [{
    key: "build",
    value: function build() {
      var _this = this;

      var fields = this._formFields.map(function (field) {
        return _this.getField(field);
      });

      fields.forEach(function (field) {
        var groupID = field[Fields.GroupID];

        if (groupID != null) {
          var group = _this._groups.find(function (gr) {
            return groupID === gr[Fields.ID];
          });

          if (group) {
            group['items'].push(field);
          }
        } else {
          _this._groups.push(_this.addToEmptyGroup(field));
        }
      });
      this._groups = _.sortBy(this._groups, Fields.Order);

      if (this._groups.length) {
        var groupBuilder = new GroupsBuilder(this._groups, this._formEdit);
        return groupBuilder.build();
      }

      return this._groups;
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(dataField) {
      return this._formFields.find(function (f) {
        return f.Name === dataField;
      });
    }
  }, {
    key: "addToEmptyGroup",
    value: function addToEmptyGroup(field) {
      return {
        Order: field[Fields.Order],
        IsVisible: field.visible,
        itemType: 'group',
        items: [field],
        visible: field.visible,
        ParentGroupID: null
      };
    }
  }, {
    key: "getInput",
    value: function getInput(aField) {
      var _this2 = this;

      var isRequired = Boolean(aField[Fields.ObjectFieldID_IsRequired]);
      var visible = Boolean(aField[Fields.IsVisible]);
      var disabled = this._formEdit.isReadOnlyForm ? this._formEdit.isReadOnlyForm : Boolean(aField[Fields.IsReadOnly]);
      var dxType = getControlDXType(aField);

      if (dxType === System.DX_CONTROLS.dxCheckBox) {
        isRequired = false;
      }

      return {
        label: {
          text: window.D5.isDebugMode() ? "".concat(aField[Fields.Title], " {").concat(aField[Fields.Name], "}") : aField[Fields.Title],
          location: getTitlePosition(aField),
          showColon: getTitlePosition(aField) !== 'right',
          visible: Boolean(aField[Fields.IsShowTitle])
        },
        Order: aField[Fields.Order],
        GroupID: aField[Fields.GroupID],
        dataField: aField.Name,
        visible: visible,
        disabled: disabled,
        isRequired: isRequired,
        template: function template(data, itemElement) {
          var dataField = data.dataField;

          var field = _this2.getFieldByName(dataField);

          _this2._fieldContainers.set(dataField, {
            container: itemElement,
            dxType: getControlDXType(field)
          });

          _this2.initField(field, dataField, itemElement);
        }
      };
    }
  }, {
    key: "redrawControl",
    value: function redrawControl(dataField) {
      if (!this._fieldContainers.has(dataField)) return;
      var field = this.getFieldByName(dataField);

      var _this$_fieldContainer = this._fieldContainers.get(dataField),
          container = _this$_fieldContainer.container,
          dxType = _this$_fieldContainer.dxType;

      this.destroyField(dxType, container, dataField);
      this.initField(field, dataField, container);
    }
  }, {
    key: "destroyField",
    value: function destroyField(dxType, container, dataField) {
      var control = $(container).find('.d5-field');
      $(control)[dxType]('dispose');
      $(control).remove();

      this._formEdit.editors.delete(dataField);
    }
  }, {
    key: "getField",
    value: function getField(field) {
      var _System$FIELD_TYPE = System.FIELD_TYPE,
          BUTTON = _System$FIELD_TYPE.BUTTON,
          DECORATION = _System$FIELD_TYPE.DECORATION;
      var type = getObjectFieldType(field);

      if (type === BUTTON) {
        return this.buttonTemplate(field);
      }

      if (type === DECORATION) {
        return this.decorationElFactory(field);
      }

      return this.getInput(field);
    }
  }, {
    key: "initField",
    value: function initField(field, dataField, itemElement) {
      var type = getObjectFieldType(field);
      var _System$FIELD_TYPE2 = System.FIELD_TYPE,
          NUMBER = _System$FIELD_TYPE2.NUMBER,
          DATE = _System$FIELD_TYPE2.DATE,
          BOOL = _System$FIELD_TYPE2.BOOL,
          TEXT = _System$FIELD_TYPE2.TEXT;

      if (isLookup(field) || [NUMBER, DATE, BOOL, TEXT].includes(type)) {
        this.detFieldTemplate(field, dataField, itemElement);
      }
    }
  }, {
    key: "windowHasFunction",
    value: function windowHasFunction(funcName) {
      return window[this._formEdit.name] && typeof window[this._formEdit.name][funcName] === 'function';
    }
  }, {
    key: "detFieldTemplate",
    value: function detFieldTemplate(field, dataField, itemElement) {
      var _this3 = this;

      var dictObj = getLinkedName(field);
      var dictKeyFld = getObjLinkedKeyName(field);
      var dictDisplayFld = field[Fields.DisplayField];
      var type = getD5EditorType(field);
      var typeField = getControlDXType(field);
      var dxSelectBox = System.DX_CONTROLS.dxSelectBox;
      var props = {
        dataField: dataField,
        objectName: this._objectName,
        dType: type,
        _id: "form-".concat(dataField),
        dataSource: createSelectFieldDS(dictObj, dictKeyFld, dictDisplayFld, field['_filter']),
        displayExpr: dictDisplayFld,
        valueExpr: dictKeyFld,
        allowNullState: false,
        inputAttr: {
          'd5id': "field-input-".concat(field[Fields.Name])
        },
        mode: field[Fields.DisplayType] === 3 ? 'password' : 'text',
        value: this._formData[dataField],
        disabled: Boolean(field[Fields.IsReadOnly]),
        elementAttr: {
          id: "form-edit-field-".concat(field[Fields.Name])
        },
        onValueChanged: function onValueChanged(_ref2) {
          var value = _ref2.value;
          if (_this3._formEdit.updating) return;

          _this3._formEdit.setModified();

          _this3._formEdit.formEditInstance.dxForm('instance').updateData(field.Name, Number(value));

          _this3._formData[dataField] = value;

          if (typeField === dxSelectBox) {
            _this3.onSelectFieldChanged(field);
          } else {
            _this3.onOtherFieldChanged(field);
          }
        }
      };
      this.additionPropsByType(typeField, props, field);
      var editor = FieldsFactory.create(type, props);

      this._formEdit.editors.set(dataField, editor);

      var el = editor.element();
      el.appendTo(itemElement);
    }
  }, {
    key: "additionPropsByType",
    value: function additionPropsByType(dxType, props, field) {
      var _System$DX_CONTROLS = System.DX_CONTROLS,
          dxDateBox = _System$DX_CONTROLS.dxDateBox,
          dxTextArea = _System$DX_CONTROLS.dxTextArea,
          dxNumberBox = _System$DX_CONTROLS.dxNumberBox,
          dxSelectBox = _System$DX_CONTROLS.dxSelectBox,
          dxCheckBox = _System$DX_CONTROLS.dxCheckBox;

      var initDropDown = function initDropDown(e) {
        setTimeout(function () {
          var $overlay = $('.dx-dropdowneditor-overlay'),
              $popupContent = $overlay.find('.dx-popup-content');
          $popupContent.css({
            'max-height': '278px'
          });
        });
      };

      switch (dxType) {
        case dxTextArea:
          // fontSize * LineCount + lineHeight * LineCount + paddingBottom + paddingTop
          props.height = "calc(".concat(field[Fields.LineCount], "em + ").concat(field[Fields.LineCount] * 6, "px + 15px)");
          break;

        case dxNumberBox:
          props.format = getFieldFormat(field);
          break;

        case dxCheckBox:
          props.value = Boolean(props.value);
          break;

        case dxSelectBox:
          props.onOpened = function (e) {
            initDropDown(e);
          };

          props.onContentReady = function (e) {
            initDropDown(e);
          };

          break;

        case dxDateBox:
          props.placeholder = getDatePlaceholder(getFieldFormat(field));
          props.showClearButton = true;
          props.useMaskBehavior = true;
          props.type = getFieldFormat(field);

          if (field[Fields.DisplayType] === 4) {
            props.displayCustomParam = field[Fields.DisplayCustomParam];
            props.displayType = field[Fields.DisplayType];
          }

          break;
      }
    }
  }, {
    key: "buttonTemplate",
    value: function buttonTemplate(field) {
      var _this4 = this;

      var buttonEvent = this._formEdit.buttonEvents.find(function (b) {
        return b[Fields.FormButtonID] === field.ID;
      }) || {};
      var eventName = buttonEvent[Fields.FunctionName];
      var buttonName = field[Fields.Name];
      return {
        GroupID: field[Fields.GroupID],
        visible: Boolean(field.IsVisible),
        disabled: this._formEdit.isReadOnlyForm,
        template: function template(data, element) {
          var btn = {
            text: field[Fields.Title],
            onClick: function onClick() {
              if (eventName) {
                _this4._formEdit.buttonUserEvent({
                  eventName: eventName
                });
              }
            },
            template: function template(_ref3) {
              var text = _ref3.text;
              return itemWithIconTemplate({
                text: text,
                type: System.TEMPLATE_TYPE.BUTTON,
                icon: field[Fields.Icon],
                titleType: field[Fields.TitleType]
              });
            }
          };
          $('<div>').dxButton(btn).appendTo(element);

          _this4._buttonContainers.set(buttonName, {
            container: element,
            dxType: getControlDXType(field)
          });

          return element;
        }
      };
    }
  }, {
    key: "decorationElFactory",
    value: function decorationElFactory(field) {
      switch (field.DisplayType) {
        case System.DECORATION_FIELD_TYPE.TEXT:
          return this.decorationElText(field);
      }
    }
  }, {
    key: "decorationElText",
    value: function decorationElText(field) {
      return {
        Order: field[Fields.Order],
        GroupID: field[Fields.GroupID],
        visible: field.IsVisible,
        itemType: 'group',
        cssClass: "decoration-el-".concat(field.ID),
        name: "decoration-el-".concat(field.ID),
        template: function template(data, itemElement) {
          $("<div>".concat(field.Title, "</div>")).appendTo(itemElement);
        }
      };
    }
  }, {
    key: "onSelectFieldChanged",
    value: function onSelectFieldChanged(field) {
      var formData = this._formEdit.prepareFormData();

      var tables = this._formEdit.getTablesDataToUserScript();

      var masterEv = '';

      if (typeof field.OnMasterSelectFilter === "function") {
        masterEv = 'OnMasterSelectFilter';
        console.warn(Messages.Warning.OnMasterSelectFilterDeprecated);
      } else if (typeof field.onMasterSelectFilter === "function") masterEv = 'onMasterSelectFilter';

      if (typeof field[masterEv] === 'function') {
        this._formEdit.loader.show();

        var settings = field[masterEv](this._formFields, formData);
        formEditCustomAction(this._formEdit.name, this._formEdit.getEventNameByField(field[Fields.ID], System.USER_EVENT_TYPE.ON_VALUE_CHANGED), settings.getSourceData(), settings.getSourceView(), this._formEdit.formUUID, {
          formOperation: this._formEdit.formOperation(),
          tables: tables
        });
      } else {
        this._formEdit.emitUserEvent(field[Fields.ID], System.USER_EVENT_TYPE.ON_VALUE_CHANGED);
      }
    }
  }, {
    key: "onOtherFieldChanged",
    value: function onOtherFieldChanged(field) {
      this._formEdit.setModified();

      this._formEdit.emitUserEvent(field[Fields.ID], System.USER_EVENT_TYPE.ON_VALUE_CHANGED);
    }
  }, {
    key: "changeConfigControl",
    value: function changeConfigControl(dataField, mode) {
      if (!this._fieldContainers.has(dataField)) return;

      var _this$_fieldContainer2 = this._fieldContainers.get(dataField),
          container = _this$_fieldContainer2.container,
          dxType = _this$_fieldContainer2.dxType;

      var control = $(container).find('.d5-field');
      $(control)[dxType]('option', 'disabled', mode);
    }
  }, {
    key: "changeConfigButton",
    value: function changeConfigButton(dataField, mode) {
      if (!this._buttonContainers.has(dataField)) return;

      var _this$_buttonContaine = this._buttonContainers.get(dataField),
          container = _this$_buttonContaine.container,
          dxType = _this$_buttonContaine.dxType;

      var control = $(container).find('.dx-button');
      $(control)[dxType]('option', 'disabled', mode);
    }
  }, {
    key: "formFields",
    set: function set(formFields) {
      this._formFields = formFields;
    }
  }]);

  return FormItemsBuilder;
}();

export { FormItemsBuilder as default };